import React from 'react';
import './css/Delete.css';

export const Delete = ({ deleteModalOpen, setDeleteModalOpen, handleDeleteClient, handleDeleteUser }) => {

    if (!deleteModalOpen) return null;

    return (
        <div className='delete-container'>
            <div className='delete-content'>
                <div className='delete-header'>
                    <p>Delete User</p>
                </div>
                <div className='delete-body'>
                    <div className='delete-message'>
                        <p>Are you sure you want to delete the user ?</p>
                    </div>
                    <div className='delete-buttons'>
                        <button className='delete-btn cancel' onClick={() => setDeleteModalOpen(false)}>
                            Cancel
                        </button>
                        <button className='delete-btn confirm' onClick={() => {
                            if (handleDeleteClient) handleDeleteClient();
                            if (handleDeleteUser) handleDeleteUser();
                        }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
